(() => {
  const dialog = document.getElementById('WaxerWelcome');
  const releaseCookieBanner = () => document.documentElement.classList.remove('waxer-welcome-first');
  if (!dialog || typeof dialog.showModal !== 'function') { releaseCookieBanner(); return; }
  const key = 'waxer-welcome-shown-v5';
  const previewWelcome = new URLSearchParams(window.location.search).get('preview_welcome') === '1';
  let languageResume = null;
  try { languageResume = sessionStorage.getItem('waxer-welcome-language-switch'); sessionStorage.removeItem('waxer-welcome-language-switch'); } catch (_) {}
  let returning = dialog.dataset.returningCustomer === 'true' || window.waxerCustomerSale === true;
  try {
    returning = returning || localStorage.getItem('waxer-visited') === '1';
    localStorage.setItem('waxer-visited', '1');
  } catch (_) { returning = true; }
  if (languageResume !== null) returning = dialog.dataset.returningCustomer === 'true' || window.waxerCustomerSale === true || languageResume === 'returning';
  const languageForm = dialog.querySelector('#WaxerWelcomeLanguage');
  if (languageForm) languageForm.addEventListener('submit', () => {
    const returnTo = languageForm.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    try { sessionStorage.setItem('waxer-welcome-language-switch', returning ? 'returning' : 'new'); sessionStorage.removeItem(key); } catch (_) {}
  });
  try {
    if (dialog.dataset.returningCustomer === 'true' || window.waxerCustomerSale) sessionStorage.removeItem('waxer-welcome-offer');
    else sessionStorage.setItem('waxer-welcome-offer', '1');
  } catch (_) {}
  dialog.querySelectorAll('[data-welcome-offer]').forEach(node => { node.hidden = returning; });
  dialog.querySelectorAll('[data-welcome-standard]').forEach(node => { node.hidden = !returning; });
  try { if (sessionStorage.getItem(key) && !previewWelcome) { releaseCookieBanner(); return; } } catch (_) { releaseCookieBanner(); return; }
  dialog.addEventListener('close', releaseCookieBanner);
  dialog.querySelectorAll('[data-waxer-welcome-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  const visible = selector => Array.from(document.querySelectorAll(selector)).some(node => {
    const style = getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getBoundingClientRect().height > 0;
  });
  let checks = 0;
  const attempt = () => {
    if (++checks > 30) { releaseCookieBanner(); return; }
    if (document.body.classList.contains('mobile-menu-open') || visible('#HeaderMiniCart .mini-cart-wrap')) {
      setTimeout(attempt, 1000);
      return;
    }
    try { sessionStorage.setItem(key, '1'); } catch (_) { releaseCookieBanner(); return; }
    document.documentElement.classList.add('waxer-welcome-first');
    dialog.showModal();
  };
  setTimeout(attempt, 800);
})();
